import { render, staticRenderFns } from "./SpamReportComponent.vue?vue&type=template&id=88b5994e&"
import script from "./SpamReportComponent.vue?vue&type=script&lang=js&"
export * from "./SpamReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports